(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.homepageSustainabilitySlider = {
    attach: function(context, settings) {
      const $block = jQuery('.view-display-id-homepage_sustainability_slider');
      const $slider = $block.find('.view-content');
      let winResizeBounce = null;

      const hpSustainabilitySliderWidth = function() {
        const $slides = $slider.find('.slick-slide');
        const $currentSlide = $slider.find('.slick-slide.slick-current');
        const $slickList = $slider.find('.slick-list');
        const $slickTrack = $slider.find('.slick-track');
        const winWidth = window.innerWidth;
        let listWidth = $slider.outerWidth();
        let trackLeft = 0;
        let slideWidth = window.innerWidth - 30;

        if (winWidth > 576) {
          slideWidth = Math.min(450, listWidth);
        }
        $slider.css({'width': winWidth + 'px'});
        $slides.css('width', slideWidth + 'px');
        $slickList.css({'width': listWidth + 'px', 'padding': ''});

        setTimeout(function() {
          // move the track left to line up the slide with the container
          $slickTrack.css({'left': ''});
          if (winWidth > 576) {
            trackLeft = ($slickList.offset().left - $currentSlide.offset().left);
          }
          $slickTrack.css({'left': trackLeft + 'px'});
        }, 200);
      };

      const initHpSustainabilitySlider = function() {
        const $nav = $block.find('.slick-arrows');
        let $prevArrow = $nav.find('.slick-prev');
        let $nextArrow = $nav.find('.slick-next');
        if ($prevArrow.length === 0) {
          $prevArrow = jQuery('<button type="button" class="slick-prev slick-arrow" aria-label="Previous">Previous</button>');
          $nav.append($prevArrow);
        }
        if ($nextArrow.length === 0) {
          $nextArrow = jQuery('<button type="button" class="slick-next slick-arrow" aria-label="Next">Next</button>');
          $nav.append($nextArrow);
        }

        $slider
          .on('init', function(event, slick) {
            hpSustainabilitySliderWidth();
          })
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            dots: false,
            variableWidth: true,
            prevArrow: '.slick-arrows .slick-prev',
            nextArrow: '.slick-arrows .slick-next',
            rows: 0
          });
      };

      jQuery(document).ready(function() {
        if (!window.hpSustainabilitySliderInit) {
          window.hpSustainabilitySliderInit = true;
          initHpSustainabilitySlider();
        }
      });

      jQuery(window).resize(function() {
        winResizeBounce = setTimeout(function() {
          clearTimeout(winResizeBounce);
          hpSustainabilitySliderWidth();
        }, 200);
      });
    }
  };
})(jQuery, Drupal);
